export const SPRING_CONFIG_700_50 = Object.freeze({
    tension: 700,
    friction: 50,
});
export const SPRING_CONFIG_700_40 = Object.freeze({
    tension: 700,
    friction: 40,
});
export const SPRING_CONFIG_300_30 = Object.freeze({
    tension: 300,
    friction: 30,
});
/** @deprecated use SPRING_CONFIG_700_50 */
export const SPRING_CONFIG_SNAPPY = SPRING_CONFIG_700_50;
/** @deprecated use SPRING_CONFIG_300_30 */
export const SPRING_CONFIG_QUICK = SPRING_CONFIG_300_30;
//# sourceMappingURL=config.js.map